export interface FetchError {
  readonly data: {
    // FIXME: is this right?
    readonly error: string;
    readonly message: string;
    readonly code: string;
    readonly 'trace-id': string;
  };
  readonly status: number;
}

export const isFetchError = (error: unknown): error is FetchError => {
  return (
    !!error &&
    typeof error === 'object' &&
    'data' in error &&
    !!error.data &&
    typeof error.data === 'object' &&
    'message' in error.data &&
    typeof error.data.message === 'string' &&
    'trace-id' in error.data &&
    typeof error.data['trace-id'] === 'string' &&
    'status' in error &&
    typeof error.status === 'number'
  );
};
